import React from "react";

interface ProfileInitialsProps {
  name: string;
  className?: string;
}

export const ProfileInitials: React.FC<ProfileInitialsProps> = ({
  name,
  className = "w-14 h-14 text-2xl",
}) => {
  const initial = name.charAt(0).toUpperCase();

  return (
    <div
      className={`${className} rounded-full bg-primary flex items-center justify-center text-[#FFF] font-bold flex-shrink-0`}
    >
      {initial}
    </div>
  );
};
